class ProductTemplate extends HTMLElement {
    constructor() {
        super();

        this._productCache = new Map();   // cache { handle -> product.json }
        this._progressCurrent = 0;
    }

    connectedCallback() {
        this.initSwiper();
        this.initVideoOptimization();
        this.calculateShipping();
        this.querySelectorAll(".faq-item-title").forEach((button) => {
            button.addEventListener("click", this.toggleFaqItem.bind(this));
        });

        this.initQuantitySteps();
        this.updateButtonPrice();
        this.initSubscriptionPicker();


        this.querySelectorAll('[data-open-modal]').forEach((button) => {
            button.addEventListener('click', (e) => {
                this.openModal(e.currentTarget.getAttribute('data-product-handle'));
            });
        });


        this.querySelectorAll('.product-form__submit[data-action="add-to-cart"]').forEach((button) => {
            button.addEventListener('click', async (e) => {
                e.preventDefault();
                const variantId = button.getAttribute('variant-id');
                const qty = button.getAttribute('data-quantity') || 1;
                const properties = button.getAttribute('data-properties') ? JSON.parse(button.getAttribute('data-properties')) : null;

                // Check direct checkout settings
                const directCheckout = this.getAttribute('data-direct-checkout') === 'true';
                const clearCart = this.getAttribute('data-clear-cart') === 'true';

                // Disable the button and change text to indicate loading
                const originalText = button.innerHTML;
                const stickyButton = this.querySelector('.product-form__sticky-submit-button button');
                const originalText2 = stickyButton ? stickyButton.innerHTML : '';
                button.disabled = true;
                button.setAttribute('aria-busy', 'true');
                button.innerHTML = '<span class=" fw-6">AJOUT... </span>';
                if (stickyButton) {
                    stickyButton.innerHTML = '<span class=" fw-6">AJOUT... </span>';
                }
                try {
                    // If direct checkout is enabled and clear cart is true, clear the cart first
                    if (directCheckout && clearCart) {
                        await fetch('/cart/clear.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json',
                            },
                            credentials: 'same-origin',
                        });
                    }

                    const randomId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
                    const finalProperties = { ...(properties || {}), _random: randomId };

                    // Read selling_plan from subscription picker if present
                    const sellingPlanInput = this.querySelector('[data-selling-plan-input]');
                    const sellingPlanId = sellingPlanInput ? sellingPlanInput.value : '';

                    // Get Recharge bundle ID for all products with selling plans (even one-time)
                    const hasSellingPlans = this.subscriptionData?.sellingPlans?.length > 0;
                    if (hasSellingPlans) {
                        if (typeof recharge === 'undefined') {
                            console.error('[Recharge] window.recharge est UNDEFINED — le script Recharge n\'est pas chargé.');
                        } else if (!recharge.bundle) {
                            console.error('[Recharge] recharge.bundle est UNDEFINED.', 'recharge keys:', Object.keys(recharge));
                        } else {
                            try {
                                const productFormEl = button.closest('product-form');
                                const bundleProductId = productFormEl?.dataset.productId || '';
                                const bundleSellingPlanId = sellingPlanId || String(this.subscriptionData.sellingPlans[0].id);
                                const activePlanName = this.getActiveSellingPlanName?.() || '';

                                // Check if pack-variant-builder is present for pack products
                                const packVariantBuilder = document.querySelector('[data-pack-variant-builder]');
                                let selections;

                                console.log('[Recharge] packVariantBuilder element:', !!packVariantBuilder, '__instance:', !!packVariantBuilder?.__instance);

                                if (packVariantBuilder && packVariantBuilder.__instance) {
                                    // Pack product: get selections from pack-variant-builder
                                    selections = packVariantBuilder.__instance.getRechargeSelections(activePlanName);
                                    // If no selling plan active, set all to first available
                                    if (!sellingPlanId) {
                                        selections.forEach(sel => {
                                            if (!sel.sellingPlan) sel.sellingPlan = String(bundleSellingPlanId);
                                        });
                                    }
                                } else {
                                    // Simple product: single selection
                                    const rechargeCollections = this.subscriptionData?.rechargeCollections || [];
                                    const collectionId = rechargeCollections.length > 0 ? String(rechargeCollections[0]) : '';
                                    selections = [{
                                        externalProductId: String(bundleProductId),
                                        externalVariantId: String(variantId),
                                        collectionId: String(collectionId),
                                        quantity: parseInt(qty),
                                        sellingPlan: String(bundleSellingPlanId)
                                    }];
                                }

                                const bundle = {
                                    externalProductId: String(bundleProductId),
                                    externalVariantId: String(variantId),
                                    selections: selections
                                };

                                console.log('[Recharge] bundle:', JSON.stringify(bundle, null, 2));

                                const isValid = await recharge.bundle.validateBundle(bundle);
                                console.log('[Recharge] validateBundle:', isValid);

                                const { valid, error } = await recharge.bundle.validateBundleSelection(bundle);
                                console.log('[Recharge] validateBundleSelection:', valid, error);

                                if (isValid && valid) {
                                    const rbId = await recharge.bundle.getBundleId(bundle);
                                    console.log('[Recharge] _rb_id:', rbId);
                                    finalProperties._rb_id = rbId;
                                    finalProperties._rb_selections = JSON.stringify(bundle);
                                } else {
                                    console.error('[Recharge] validation failed — validateBundle:', isValid, '— validateBundleSelection:', error, bundle);
                                }
                            } catch(e) {
                                console.error('[Recharge] Erreur getBundleId:', e);
                            }
                        }
                    }

                    const cartBody = { id: variantId, quantity: qty, properties: finalProperties };
                    if (sellingPlanId) {
                        cartBody.selling_plan = parseInt(sellingPlanId);
                    }

                    await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                        },
                        body: JSON.stringify(cartBody),
                        credentials: 'same-origin',
                    });
                    button.innerHTML = '<span class=" fw-6">AJOUTÉ </span>';

                    if (stickyButton) {
                        stickyButton.innerHTML = '<span class=" fw-6">AJOUTÉ </span>';
                    }

                    // If direct checkout is enabled, redirect to checkout
                    if (directCheckout) {
                        window.location.href = '/checkout';
                        return;
                    }

                    // Dispatch product:added event for sidecart to handle
                    document.dispatchEvent(new CustomEvent('product:added'));

                    // Open the sidecart
                    const sideCart = document.querySelector('side-cart');
                    if (sideCart) {
                        sideCart.classList.add('open');
                    }

                    await this.refreshQuantitySteps();
                    await this.updateButtonPrice();

                } catch (error) {
                    console.error('Erreur lors de l\'ajout au panier:', error); 
                    button.innerHTML = originalText; // Restore original text on error
                } finally {
                    if (!directCheckout) {
                        button.disabled = false;
                        button.removeAttribute('aria-busy');
                        button.innerHTML = originalText; // Restore original text
                        if (stickyButton) {
                            stickyButton.innerHTML = originalText2; // Restore original text
                        }
                    }
                }
            });
        });


        const regularStickyBtn = this.querySelector('.product-form__sticky-submit-button button');
        if (regularStickyBtn) {
            regularStickyBtn.addEventListener('click', (e) => {
                this.querySelector('.product-form__submit[data-action="add-to-cart"]').click();
            });
        }

        const packVariantStickyBtn = this.querySelector('[data-pack-variant-sticky-cta]');
        if (packVariantStickyBtn) {
            packVariantStickyBtn.addEventListener('click', (e) => {
                this.querySelector('.product-form__submit[data-action="add-to-cart"]').click();
            });
        }



        // when .product-form__content is out of view, add the class 'is-open' from .product-form__sticky
        const productFormContent = this.querySelector('.product-form');
        const productFormSticky = this.querySelector('.product-form__sticky');
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) {
                    productFormSticky.classList.add('is-open');
                } else {
                    productFormSticky.classList.remove('is-open');
                }
            });
        }, {
            root: null,
            threshold: 0.1 // Trigger when 10% of the element is visible
        });

        observer.observe(productFormContent);
        // Set the initial state of the sticky element
        if (productFormContent.getBoundingClientRect().top < window.innerHeight) {
            productFormSticky.classList.remove('is-open');
        }
    }

    initSwiper() {
        const swiperContainer = this.querySelector('.product-media__slider');
        const thumbsContainer = this.querySelector('.product-media__thumbs');

        // Initialize thumbs swiper first
        let thumbsSwiper = null;
        if (thumbsContainer) {
            thumbsSwiper = new Swiper(thumbsContainer, {
                slidesPerView: 'auto',
                spaceBetween: 6,
                watchSlidesProgress: true,
            });
            this.thumbsSwiperInstance = thumbsSwiper;
        }

        const swiper = new Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 6,
            pagination: {
                el: '.product-media__slider .swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.product-media .swiper-next',
                prevEl: '.product-media .swiper-prev',
            },
            breakpoints: {
                990: {
                    slidesPerView: 1,
                },
            },
            on: {
                slideChange: () => {
                    this.handleVideoSlideChange(swiper);
                    this.updateActiveThumbnail(swiper.activeIndex);
                }
            }
        });

        // Store swiper instance for video management
        this.swiperInstance = swiper;

        // Add click handlers to thumbnails
        if (thumbsContainer) {
            const thumbs = thumbsContainer.querySelectorAll('.product-media__thumb');
            thumbs.forEach((thumb) => {
                thumb.addEventListener('click', () => {
                    const index = parseInt(thumb.getAttribute('data-index'), 10);
                    swiper.slideTo(index);
                });
            });
        }
    }

    updateActiveThumbnail(activeIndex) {
        const thumbsContainer = this.querySelector('.product-media__thumbs');
        if (!thumbsContainer) return;

        const thumbs = thumbsContainer.querySelectorAll('.product-media__thumb');
        thumbs.forEach((thumb, index) => {
            if (index === activeIndex) {
                thumb.classList.add('product-media__thumb--active');
            } else {
                thumb.classList.remove('product-media__thumb--active');
            }
        });

        // Scroll the thumbs swiper to make active thumbnail visible
        if (this.thumbsSwiperInstance) {
            this.thumbsSwiperInstance.slideTo(Math.max(0, activeIndex - 1));
        }
    }

    initVideoOptimization() {
        const videos = this.querySelectorAll('.product-media__video, .product-media__bottom-video');

        // Intersection Observer pour détecter quand les vidéos entrent dans la vue
        const videoObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const video = entry.target;
                if (entry.isIntersecting) {
                    this.loadAndPlayVideo(video);
                } else {
                    this.pauseVideo(video);
                }
            });
        }, {
            root: null,
            threshold: 0.5 // Déclenche quand 50% de la vidéo est visible
        });

        videos.forEach(video => {
            videoObserver.observe(video);

            // Gestion des erreurs de chargement
            video.addEventListener('error', () => {
                console.warn('Erreur de chargement vidéo, fallback sur poster');
                video.style.backgroundImage = `url(${video.poster})`;
                video.style.backgroundSize = 'cover';
                video.style.backgroundPosition = 'center';
            });

            // Lazy loading optimisé
            video.addEventListener('loadstart', () => {
                video.style.opacity = '0';
                video.style.transition = 'opacity 0.3s ease';
            });

            video.addEventListener('loadeddata', () => {
                video.style.opacity = '1';
            });
        });
    }

    loadAndPlayVideo(video) {
        // Ne charge la vidéo que si elle n'est pas déjà chargée
        if (video.readyState === 0) {
            video.load();
        }

        // Play seulement si la vidéo est prête
        const playPromise = video.play();
        if (playPromise !== undefined) {
            playPromise.catch(error => {
                console.warn('Autoplay bloqué par le navigateur:', error);
            });
        }
    }

    pauseVideo(video) {
        if (!video.paused) {
            video.pause();
        }
    }

    handleVideoSlideChange(swiper) {
        // Pause toutes les vidéos sauf celle du slide actif
        const allVideos = this.querySelectorAll('.product-media__video');
        const activeSlide = swiper.slides[swiper.activeIndex];
        const activeVideo = activeSlide ? activeSlide.querySelector('.product-media__video') : null;

        allVideos.forEach(video => {
            if (video !== activeVideo) {
                this.pauseVideo(video);
            }
        });

        // Play la vidéo du slide actif si elle existe
        if (activeVideo) {
            this.loadAndPlayVideo(activeVideo);
        }
    }

    async getCart() {
        const res = await fetch('/cart.js', { credentials: 'same-origin' });
        if (!res.ok) throw new Error('Cart fetch failed');
        return res.json();
    }

    async getProductJSONByHandle(handle) {
        if (this._productCache.has(handle)) return this._productCache.get(handle);
        const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
        if (!res.ok) throw new Error(`Product fetch failed: ${handle}`);
        const data = await res.json();
        this._productCache.set(handle, data);

        return data;
    }

    async countBarzPacksInCart() {
        const cart = await this.getCart();
        let total = 0;
        // On limite les requêtes en parallèle et on cache par handle.
        const tasks = cart.items.map(async (item) => {
            try {
                // Exclude free items (final_price = 0) from count
                if (item.final_price === 0) {
                    console.log(`Excluding free item from count: ${item.title}`);
                    return;
                }

                const p = await this.getProductJSONByHandle(item.handle);
                // tags est un tableau de strings
                if (Array.isArray(p.tags) && p.tags.includes('tag_barz')) {
                    total += item.quantity;
                }
            } catch (e) {
                console.warn('Impossible de lire le produit du panier:', item.handle, e);
            }
        });
        await Promise.all(tasks);
        return total;
    }

    readStepsConfig() {
        const steps = this.querySelectorAll('.quantity_step__step.step');
        const barEl = this.querySelector('.quantity_step__progress-bar');

        let maxStep = 0;
        steps.forEach((el) => {
            const v = parseInt(el.getAttribute('data-quantity-step'), 10);
            if (!isNaN(v)) maxStep = Math.max(maxStep, v);
        });

        return { steps, barEl, maxStep };
    }

    /**
     * Met à jour l'état actif des steps en fonction de la quantité totale calculée.
     * Déclenche aussi tes animations CSS grâce à la classe .active.
     */
    updateStepsActive(totalQty) {
        const { steps } = this.readStepsConfig();
        steps.forEach((el) => {
            const threshold = parseInt(el.getAttribute('data-quantity-step'), 10) || 0;
            if (totalQty >= threshold && threshold > 0) {
                el.classList.add('active');
            } else {
                el.classList.remove('active');
            }
        });
    }

    /**
     * Met à jour la progress bar.
     * - Calcule le pourcentage = totalQty / maxStep (limité à 100%)
     * - Anime depuis this._progressCurrent vers la nouvelle largeur
     */
    updateProgressBar(totalQty, { animate = true } = {}) {
        const { barEl, maxStep } = this.readStepsConfig();
        if (!barEl || !maxStep) return;

        const target = Math.max(0, Math.min(100, (totalQty / maxStep) * 100));
        // Transition douce
        if (animate) {
            barEl.style.transition = 'width 300ms ease';
        } else {
            barEl.style.transition = 'none';
        }
        // Part d'où on est (au 1er init on essaie de lire le style inline)
        if (this._progressCurrent === 0) {
            const inline = parseFloat((barEl.style.width || '').replace('%', ''));
            if (!isNaN(inline)) this._progressCurrent = inline;
        }

        // Fixe la nouvelle largeur
        barEl.style.width = `${target}%`;
        this._progressCurrent = target;
    }

    /**
     * Init général: compte dans le panier, active les steps, puis règle la barre.
     */
    async initQuantitySteps() {
        // Si la section steps n’existe pas, on sort
        const stepsWrap = this.querySelector('.quantity_step--container');
        if (!stepsWrap) return;

        try {
            const totalBarz = await this.countBarzPacksInCart();
            // Steps actifs/inactifs
            this.updateStepsActive(totalBarz);
            // Progress bar (sans animation à l’init)
            this.updateProgressBar(totalBarz, { animate: false });
        } catch (e) {
            console.warn('Init steps/progress échouée:', e);
        }
    }

    /**
     * Recalcule après ajout au panier (avec animation cette fois).
     */
    async refreshQuantitySteps() {
        const stepsWrap = this.querySelector('.quantity_step--container');
        if (!stepsWrap) return;

        try {
            const totalBarz = await this.countBarzPacksInCart();
            this.updateStepsActive(totalBarz);
            this.updateProgressBar(totalBarz, { animate: true });
        } catch (e) {
            console.warn('Refresh steps/progress échouée:', e);
        }
    }

    getApplicableReduction(totalQty) {
        const steps = this.querySelectorAll('.quantity_step__step.step');
        let applicableReduction = 0;
        let highestThreshold = 0;

        steps.forEach((el) => {
            const threshold = parseInt(el.getAttribute('data-quantity-step'), 10) || 0;
            const reductionText = el.querySelector('.quantity_step__step-reduction')?.textContent || '';
            const reduction = parseInt(reductionText.replace('-', '').replace('%', ''), 10) || 0;

            if (totalQty >= threshold && threshold > highestThreshold) {
                highestThreshold = threshold;
                applicableReduction = reduction;
            }
        });

        return applicableReduction;
    }

    async updateButtonPrice() {
        const stepsWrap = this.querySelector('.quantity_step--container');
        if (!stepsWrap) return;

        const submitButton = this.querySelector('.product-form__submit[data-action="add-to-cart"]');
        const stickyButton = this.querySelector('.product-form__sticky-submit-button button');
        if (!submitButton) return;

        try {
            const totalBarz = await this.countBarzPacksInCart();
            // Calculate reduction for NEXT item (totalBarz + 1)
            const reduction = this.getApplicableReduction(totalBarz + 1);

            // Get original price from data attribute (in cents)
            const originalPriceInCents = parseFloat(submitButton.getAttribute('data-original-price'));
            const originalPrice = originalPriceInCents / 100; // Convert cents to euros

            // Calculate discounted price if reduction applies
            let discountedPrice = reduction > 0 ? originalPrice * (1 - reduction / 100) : originalPrice;

            // Round to 2 decimals first
            discountedPrice = Math.round(discountedPrice * 100) / 100;

            // Round .96 to .95
            const cents = Math.round((discountedPrice % 1) * 100);
            if (cents === 96) {
                discountedPrice = Math.floor(discountedPrice) + 0.95;
            }

            // Format prices
            const formattedDiscountedPrice = window.formatPrice(Math.round(discountedPrice * 100));
            const formattedOriginalPrice = window.formatPrice(Math.round(originalPrice * 100));

            // Helper function to update button prices
            const updateButton = (button) => {
                const priceContainer = button.querySelector('[variant-price-change]');
                if (!priceContainer) return;

                const priceElement = priceContainer.querySelector('.product-form__price');
                const comparePriceElement = priceContainer.querySelector('.product-form__compare-price');

                if (!priceElement) return;

                if (reduction > 0) {
                    // Show original price crossed out and discounted price
                    if (comparePriceElement) {
                        comparePriceElement.textContent = formattedOriginalPrice;
                        comparePriceElement.parentElement.style.display = '';
                    }
                    priceElement.textContent = formattedDiscountedPrice;
                } else {
                    // No reduction, show normal price
                    priceElement.textContent = formattedOriginalPrice;
                    if (comparePriceElement && comparePriceElement.parentElement) {
                        comparePriceElement.parentElement.style.display = 'none';
                    }
                }
            };

            // Update main submit button
            updateButton(submitButton);

            // Update sticky button
            if (stickyButton) {
                updateButton(stickyButton);
            }
        } catch (e) {
            console.warn('Update button price échouée:', e);
        }
    }

    openModal(productHandle) {
        const modal = document.querySelector('.modal-product__content');
        if (modal) {
            modal.classList.add('is-open');
            modal.innerHTML = ''; // Clear previous content
            fetch(`/products/${productHandle}?section_id=pop-up-product`)
                .then(response => response.text())
                .then(html => {
                    modal.innerHTML = html;
                    setTimeout(() => {
                        this.querySelector('.section-pop-up-product').classList.add('active');
                    }, 100);

                    this.querySelector('.section-pop-up-product .pop-up__header svg').addEventListener('click', () => {
                        this.querySelector('.section-pop-up-product').classList.remove('active');
                        setTimeout(() => {
                            modal.classList.remove('is-open');
                        }, 100);
                    });
                    this.querySelector('.pop-up__overlay').addEventListener('click', () => {
                        this.querySelector('.section-pop-up-product').classList.remove('active');
                        setTimeout(() => {
                            modal.classList.remove('is-open');
                        }, 100);
                    });
                })
                .catch(error => console.error('Error loading product modal:', error));
        }
    }


    initSubscriptionPicker() {
        this.subscriptionPicker = this.querySelector('[data-subscription-picker]');
        if (!this.subscriptionPicker) return;

        const dataEl = this.subscriptionPicker.querySelector('[data-subscription-data]');
        if (!dataEl) return;

        this.subscriptionData = JSON.parse(dataEl.textContent);
        this.sellingPlanInput = this.subscriptionPicker.querySelector('[data-selling-plan-input]');
        this.subscriptionOptions = this.subscriptionPicker.querySelectorAll('.subscription-picker__option');
        this.subscriptionTabButtons = this.subscriptionPicker.querySelectorAll('.subscription-picker__tab');
        this.subscriptionTabs = this.subscriptionPicker.querySelector('[data-frequency-tabs]');

        // Bind option click events
        this.subscriptionOptions.forEach(option => {
            option.addEventListener('click', () => this.handleSubscriptionOptionClick(option));
        });

        // Bind frequency tab click events
        this.subscriptionTabButtons.forEach((tab, index) => {
            tab.addEventListener('click', (e) => {
                e.stopPropagation();
                this.handleFrequencyTabClick(tab, index);
            });
        });

        // Make entire subscribe container clickable
        const subscribeContainer = this.subscriptionPicker.querySelector('.subscription-picker__option--subscribe');
        if (subscribeContainer) {
            subscribeContainer.addEventListener('click', (e) => {
                if (e.target.closest('.subscription-picker__tab')) return;
                const subscribeOption = this.subscriptionPicker.querySelector('[data-subscription-type="subscribe"]');
                if (subscribeOption) {
                    this.handleSubscriptionOptionClick(subscribeOption);
                }
            });
        }

        // Initialize state if subscription is pre-selected
        if (this.subscriptionData?.subscriptionActive) {
            this.subscriptionPicker.classList.add('is-subscribe-active');
            this.updateBuyButtonPrice(true);
            this.refreshPickerPrices();
            this.updatePackBuilderPrices(true);
        }

        // Filter frequency tabs on init for the current variant
        const submitButton = this.querySelector('.product-form__submit[data-action="add-to-cart"]');
        const initVariantId = submitButton?.getAttribute('variant-id');
        if (initVariantId && this.subscriptionData?.variants) {
            const variantData = this.subscriptionData.variants[String(initVariantId)];
            const allocations = variantData?.allocations || {};
            const allTabs = this.subscriptionPicker.querySelectorAll('.subscription-picker__tab');
            let hasActiveTab = false;
            allTabs.forEach(tab => {
                const tabPlanId = tab.dataset.sellingPlanId;
                const hasAlloc = allocations.hasOwnProperty(String(tabPlanId));
                tab.style.display = hasAlloc ? '' : 'none';
                if (!hasAlloc && tab.classList.contains('is-active')) {
                    tab.classList.remove('is-active');
                }
                if (hasAlloc && tab.classList.contains('is-active')) {
                    hasActiveTab = true;
                }
            });
            if (!hasActiveTab) {
                const firstVisible = Array.from(allTabs).find(t => t.style.display !== 'none');
                if (firstVisible) {
                    firstVisible.classList.add('is-active');
                    if (this.sellingPlanInput) {
                        this.sellingPlanInput.value = firstVisible.dataset.sellingPlanId;
                    }
                }
            }
        }

    }

    handleSubscriptionOptionClick(option) {
        const type = option.dataset.subscriptionType;
        const isOneTime = type === 'one-time';

        // Update option states
        this.subscriptionOptions.forEach(opt => {
            const isActive = opt.dataset.subscriptionType === type;
            opt.classList.toggle('is-active', isActive);
            opt.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        // Update container state for CSS
        this.subscriptionPicker.classList.toggle('is-subscribe-active', !isOneTime);

        // Update selling plan input
        if (isOneTime) {
            this.sellingPlanInput.value = '';
        } else {
            const activeTab = this.subscriptionPicker.querySelector('.subscription-picker__tab.is-active');
            if (activeTab) {
                this.sellingPlanInput.value = activeTab.dataset.sellingPlanId;
            }
        }

        // Update buy button price
        this.updateBuyButtonPrice(!isOneTime);

        // Refresh subscription picker prices with current variant data
        this.refreshPickerPrices();

        // Update pack builder prices (step prices + variant unit prices)
        this.updatePackBuilderPrices(!isOneTime);
    }

    handleFrequencyTabClick(tab, index) {
        // Update active states
        this.subscriptionTabButtons.forEach(t => {
            t.classList.remove('is-active');
        });
        tab.classList.add('is-active');

        // Update selling plan input
        this.sellingPlanInput.value = tab.dataset.sellingPlanId;

        // Update prices for this frequency
        this.updateSubscriptionPrices(tab);

        // Make sure subscribe option is active
        const subscribeOption = tab.closest('.subscription-picker__option--subscribe');
        if (subscribeOption && !subscribeOption.classList.contains('is-active')) {
            this.handleSubscriptionOptionClick(subscribeOption);
        }
    }

    updateSubscriptionPrices(tab) {
        this.refreshPickerPrices();
        this.updateBuyButtonPrice(true);
        this.updatePackBuilderPrices(true);
    }

    updateBuyButtonPrice(withSubscription = false) {
        const submitButton = this.querySelector('.product-form__submit[data-action="add-to-cart"]');
        if (!submitButton || !this.subscriptionData) return;

        const originalPriceInCents = parseFloat(submitButton.getAttribute('data-original-price'));
        let finalPrice = originalPriceInCents;

        if (withSubscription) {
            const variantId = submitButton.getAttribute('variant-id');
            const planId = this.getActiveSellingPlanId();
            const discountPercent = this.getVariantDiscountPercent(variantId, planId);
            if (discountPercent) {
                const discount = Math.round(originalPriceInCents * discountPercent / 100);
                finalPrice = originalPriceInCents - discount;
            }
        }

        const priceContainer = submitButton.querySelector('[variant-price-change]');
        if (!priceContainer) return;

        const priceElement = priceContainer.querySelector('.product-form__price');
        const comparePriceElement = priceContainer.querySelector('.product-form__compare-price');

        if (priceElement) {
            priceElement.textContent = window.formatPrice(finalPrice);
        }

        if (comparePriceElement) {
            if (withSubscription) {
                comparePriceElement.textContent = window.formatPrice(originalPriceInCents);
                comparePriceElement.parentElement.style.display = '';
            } else {
                const comparePrice = parseFloat(submitButton.getAttribute('data-compare-price'));
                if (comparePrice > originalPriceInCents) {
                    comparePriceElement.textContent = window.formatPrice(comparePrice);
                    comparePriceElement.parentElement.style.display = '';
                } else {
                    comparePriceElement.parentElement.style.display = 'none';
                }
            }
        }

        // Update sticky button too
        const stickyButton = this.querySelector('.product-form__sticky-submit-button button');
        if (stickyButton) {
            const stickyPriceContainer = stickyButton.querySelector('[variant-price-change]');
            if (stickyPriceContainer) {
                const stickyPrice = stickyPriceContainer.querySelector('.product-form__price');
                const stickyCompare = stickyPriceContainer.querySelector('.product-form__compare-price');
                if (stickyPrice) stickyPrice.textContent = window.formatPrice(finalPrice);
                if (stickyCompare && withSubscription) {
                    stickyCompare.textContent = window.formatPrice(originalPriceInCents);
                    stickyCompare.parentElement.style.display = '';
                }
            }
        }
    }

    /**
     * Refresh all prices inside the subscription picker block
     * based on current subscriptionData (oneTimePrice, discountPercent, etc.)
     */
    refreshPickerPrices() {
        if (!this.subscriptionPicker || !this.subscriptionData) return;

        const oneTimePrice = this.subscriptionData.oneTimePrice;
        const comparePrice = this.subscriptionData.comparePrice;
        const unitPrice = this.subscriptionData.oneTimeUnitPrice;

        // Get active discount per variant
        const submitButton = this.querySelector('.product-form__submit[data-action="add-to-cart"]');
        const variantId = submitButton?.getAttribute('variant-id');
        const planId = this.getActiveSellingPlanId();
        const discountPercent = this.getVariantDiscountPercent(variantId, planId);

        const savings = Math.round(oneTimePrice * discountPercent / 100);
        const subscriptionPrice = oneTimePrice - savings;

        // Subscribe prices
        const subPriceEl = this.subscriptionPicker.querySelector('[data-subscription-price]');
        const subCompareEl = this.subscriptionPicker.querySelector('[data-compare-price]');
        if (subPriceEl) subPriceEl.textContent = window.formatPrice(subscriptionPrice);
        if (subCompareEl) subCompareEl.textContent = window.formatPrice(comparePrice);

        // Subscribe unit price
        const subUnitEl = this.subscriptionPicker.querySelector('[data-subscription-unit-price]');
        if (subUnitEl && unitPrice) {
            const unitSavings = Math.round(unitPrice * discountPercent / 100);
            const suffix = subUnitEl.dataset.unitSuffix || '';
            subUnitEl.textContent = window.formatPrice(unitPrice - unitSavings) + (suffix ? ' ' + suffix : '');
        }

        // One-time prices
        const otPriceEl = this.subscriptionPicker.querySelector('[data-one-time-price]');
        const otCompareEl = this.subscriptionPicker.querySelector('[data-one-time-compare]');
        if (otPriceEl) otPriceEl.textContent = window.formatPrice(oneTimePrice);
        if (otCompareEl) otCompareEl.textContent = window.formatPrice(comparePrice);

        // One-time unit price
        const otUnitEl = this.subscriptionPicker.querySelector('[data-one-time-unit-price]');
        if (otUnitEl && unitPrice) {
            const suffix = otUnitEl.dataset.unitSuffix || '';
            otUnitEl.textContent = window.formatPrice(unitPrice) + (suffix ? ' ' + suffix : '');
        }

        // Update badge and benefit texts with current variant discount %
        const badge = this.subscriptionPicker.querySelector('.subscription-picker__badge');
        if (badge && badge.dataset.template) {
            badge.textContent = badge.dataset.template.replace('{percent}', discountPercent);
        }
        const benefits = this.subscriptionPicker.querySelectorAll('.subscription-picker__benefit-text');
        benefits.forEach(el => {
            if (el.dataset.template) {
                el.textContent = el.dataset.template.replace('{percent}', discountPercent);
            }
        });
    }

    /**
     * Update pack-builder step prices and variant unit prices
     * when toggling subscribe/one-time
     */
    updatePackBuilderPrices(withSubscription = false) {
        if (!this.subscriptionData) return;

        const submitBtn2 = this.querySelector('.product-form__submit[data-action="add-to-cart"]');
        const variantId = submitBtn2?.getAttribute('variant-id');
        const planId = this.getActiveSellingPlanId();
        const discountPercent = withSubscription ? this.getVariantDiscountPercent(variantId, planId) : 0;

        // Update step header price (data-variant-price / data-variant-compare-price)
        const stepPrice = this.querySelector('[data-variant-price]');
        const stepCompare = this.querySelector('[data-variant-compare-price]');
        if (stepPrice) {
            const submitBtn = this.querySelector('.product-form__submit[data-action="add-to-cart"]');
            const originalPrice = submitBtn ? parseFloat(submitBtn.getAttribute('data-original-price')) : 0;
            if (originalPrice) {
                const discount = Math.round(originalPrice * discountPercent / 100);
                stepPrice.textContent = window.formatPrice(originalPrice - discount);
            }
        }
        if (stepCompare && withSubscription && stepPrice) {
            const submitBtn = this.querySelector('.product-form__submit[data-action="add-to-cart"]');
            const originalPrice = submitBtn ? parseFloat(submitBtn.getAttribute('data-original-price')) : 0;
            if (originalPrice) {
                stepCompare.textContent = window.formatPrice(originalPrice);
                stepCompare.style.display = '';
            }
        } else if (stepCompare && !withSubscription) {
            const submitBtn = this.querySelector('.product-form__submit[data-action="add-to-cart"]');
            const comparePrice = submitBtn ? parseFloat(submitBtn.getAttribute('data-compare-price')) : 0;
            const originalPrice = submitBtn ? parseFloat(submitBtn.getAttribute('data-original-price')) : 0;
            if (comparePrice > originalPrice) {
                stepCompare.textContent = window.formatPrice(comparePrice);
                stepCompare.style.display = '';
            } else {
                stepCompare.style.display = 'none';
            }
        }

        // Update all variant buttons unit prices (each with its own discount %)
        const variantButtons = this.querySelectorAll('.pack-builder__variant');
        variantButtons.forEach(btn => {
            const unitPriceEl = btn.querySelector('.pack-builder__variant-unit');
            if (!unitPriceEl) return;

            // Get original unit price from data or text
            let originalUnit = parseFloat(btn.dataset.variantUnitPrice);
            if (!originalUnit) {
                // Parse from current text as fallback and store
                const text = unitPriceEl.textContent;
                const match = text.match(/([\d,]+)/);
                if (match) {
                    originalUnit = parseFloat(match[1].replace(',', '.')) * 100;
                    btn.dataset.variantUnitPrice = originalUnit;
                }
            }

            if (!originalUnit) return;

            // Get per-variant discount using each variant's own first available plan
            const btnVariantId = btn.dataset.variantId;
            let btnPlanId = planId;
            if (withSubscription && this.subscriptionData?.variants) {
                const btnVariantData = this.subscriptionData.variants[String(btnVariantId)];
                if (btnVariantData?.allocations) {
                    const btnAllocKeys = Object.keys(btnVariantData.allocations);
                    if (btnAllocKeys.length > 0) btnPlanId = btnAllocKeys[0];
                }
            }
            const btnDiscountPercent = withSubscription ? this.getVariantDiscountPercent(btnVariantId, btnPlanId) : 0;

            const unitDiscount = Math.round(originalUnit * btnDiscountPercent / 100);
            const finalUnit = originalUnit - unitDiscount;
            const suffix = unitPriceEl.dataset.unitSuffix || '';
            unitPriceEl.textContent = window.formatPrice(finalUnit) + (suffix ? ' ' + suffix : '');
        });

        // Update pack-variant-builder card prices (each with its own discount %)
        const pvbCards = this.querySelectorAll('.pack-variant-builder__card');
        pvbCards.forEach(card => {
            const priceEl = card.querySelector('.pack-variant-builder__card-current');
            if (!priceEl) return;

            const cardVariantId = card.dataset.variantId;
            const variantData = this.subscriptionData.variants?.[String(cardVariantId)];
            const originalPrice = variantData ? variantData.price : 0;
            if (!originalPrice) return;

            let cardPlanId = planId;
            if (withSubscription && variantData?.allocations) {
                const cardAllocKeys = Object.keys(variantData.allocations);
                if (cardAllocKeys.length > 0) cardPlanId = cardAllocKeys[0];
            }
            const cardDiscount = withSubscription ? this.getVariantDiscountPercent(cardVariantId, cardPlanId) : 0;
            const savings = Math.round(originalPrice * cardDiscount / 100);
            priceEl.textContent = window.formatPrice(originalPrice - savings);
        });
    }


    /**
     * Update subscription picker prices when variant changes
     */
    updateSubscriptionPickerPrices(variant) {
        if (!this.subscriptionPicker || !this.subscriptionData) return;

        // Get variant data from our own JSON (has unit_price)
        const variantData = this.subscriptionData.variants?.[String(variant.id)];
        const newPrice = variantData ? variantData.price : variant.price;
        const newComparePrice = variantData ? variantData.compareAtPrice : (variant.compare_at_price || newPrice);
        const newUnitPrice = variantData ? variantData.unitPrice : 0;

        // Update subscription data with new variant prices
        this.subscriptionData.oneTimePrice = newPrice;
        this.subscriptionData.comparePrice = newComparePrice;
        this.subscriptionData.oneTimeUnitPrice = newUnitPrice;

        // Get active discount per variant
        const planId = this.getActiveSellingPlanId();
        const discountPercent = this.getVariantDiscountPercent(variant.id, planId);

        const savings = Math.round(newPrice * discountPercent / 100);
        const subscriptionPrice = newPrice - savings;

        // Update subscribe option prices
        const subPriceEl = this.subscriptionPicker.querySelector('[data-subscription-price]');
        const subCompareEl = this.subscriptionPicker.querySelector('[data-compare-price]');
        if (subPriceEl) subPriceEl.textContent = window.formatPrice(subscriptionPrice);
        if (subCompareEl) subCompareEl.textContent = window.formatPrice(newComparePrice);

        // Update subscribe unit price
        const subUnitEl = this.subscriptionPicker.querySelector('[data-subscription-unit-price]');
        if (subUnitEl && newUnitPrice) {
            const unitSavings = Math.round(newUnitPrice * discountPercent / 100);
            const subUnit = newUnitPrice - unitSavings;
            const suffix = subUnitEl.dataset.unitSuffix || '';
            subUnitEl.textContent = window.formatPrice(subUnit) + (suffix ? ' ' + suffix : '');
        }

        // Update one-time option prices
        const otPriceEl = this.subscriptionPicker.querySelector('[data-one-time-price]');
        const otCompareEl = this.subscriptionPicker.querySelector('[data-one-time-compare]');
        if (otPriceEl) otPriceEl.textContent = window.formatPrice(newPrice);
        if (otCompareEl) otCompareEl.textContent = window.formatPrice(newComparePrice);

        // Update one-time unit price
        const otUnitEl = this.subscriptionPicker.querySelector('[data-one-time-unit-price]');
        if (otUnitEl && newUnitPrice) {
            const suffix = otUnitEl.dataset.unitSuffix || '';
            otUnitEl.textContent = window.formatPrice(newUnitPrice) + (suffix ? ' ' + suffix : '');
        }

        // Filter frequency tabs: hide plans that have no allocation for this variant
        const allocations = variantData?.allocations || {};
        const allTabs = this.subscriptionPicker.querySelectorAll('.subscription-picker__tab');
        let hasActiveTab = false;
        allTabs.forEach(tab => {
            const tabPlanId = tab.dataset.sellingPlanId;
            const hasAlloc = allocations.hasOwnProperty(String(tabPlanId));
            tab.style.display = hasAlloc ? '' : 'none';
            if (!hasAlloc && tab.classList.contains('is-active')) {
                tab.classList.remove('is-active');
            }
            if (hasAlloc && tab.classList.contains('is-active')) {
                hasActiveTab = true;
            }
        });
        // If no tab is active, activate the first visible one
        if (!hasActiveTab) {
            const firstVisible = Array.from(allTabs).find(t => t.style.display !== 'none');
            if (firstVisible) {
                firstVisible.classList.add('is-active');
                if (this.sellingPlanInput) {
                    this.sellingPlanInput.value = firstVisible.dataset.sellingPlanId;
                }
            }
        }

        // Recalculate all prices with the correct active plan after tab filtering
        const activePlanId = this.getActiveSellingPlanId();
        const activeDiscount = this.getVariantDiscountPercent(variant.id, activePlanId);
        const activeSavings = Math.round(newPrice * activeDiscount / 100);
        if (subPriceEl) subPriceEl.textContent = window.formatPrice(newPrice - activeSavings);

        // Update unit price with correct discount
        if (subUnitEl && newUnitPrice) {
            const unitSavings = Math.round(newUnitPrice * activeDiscount / 100);
            const suffix = subUnitEl.dataset.unitSuffix || '';
            subUnitEl.textContent = window.formatPrice(newUnitPrice - unitSavings) + (suffix ? ' ' + suffix : '');
        }

        // Update badge and benefit texts with variant-specific discount %
        const badge = this.subscriptionPicker.querySelector('.subscription-picker__badge');
        if (badge && badge.dataset.template) {
            badge.textContent = badge.dataset.template.replace('{percent}', activeDiscount);
        }
        const benefits = this.subscriptionPicker.querySelectorAll('.subscription-picker__benefit-text');
        benefits.forEach(el => {
            if (el.dataset.template) {
                el.textContent = el.dataset.template.replace('{percent}', activeDiscount);
            }
        });

        // Update buy button & pack builder prices with correct discount
        const isSubscribeActive = this.subscriptionPicker.classList.contains('is-subscribe-active');
        this.updateBuyButtonPrice(isSubscribeActive);
        this.updatePackBuilderPrices(isSubscribeActive);

    }

    /**
     * Get the discount percent for a specific variant + selling plan.
     * Uses per-variant allocations if available, falls back to global plan discount.
     */
    getVariantDiscountPercent(variantId, sellingPlanId) {
        if (!this.subscriptionData) return this.subscriptionData?.discountPercent || 0;

        // Try variant-specific allocation first
        const variantData = this.subscriptionData.variants?.[String(variantId)];
        if (variantData?.allocations && sellingPlanId) {
            const alloc = variantData.allocations[String(sellingPlanId)];
            if (alloc) return alloc.discountPercent;
        }

        // Fallback: plan-level discount
        if (sellingPlanId) {
            const plan = this.subscriptionData.sellingPlans.find(sp => String(sp.id) === String(sellingPlanId));
            if (plan) return plan.discountPercent;
        }

        return this.subscriptionData.discountPercent || 0;
    }

    /**
     * Get the active selling plan ID from the subscription picker
     */
    getActiveSellingPlanId() {
        const activeTab = this.subscriptionPicker?.querySelector('.subscription-picker__tab.is-active');
        return activeTab ? activeTab.dataset.sellingPlanId : (this.subscriptionData?.sellingPlans?.[0]?.id || '');
    }

    /**
     * Get the active selling plan name from the subscription picker
     */
    getActiveSellingPlanName() {
        if (!this.subscriptionData) return '';
        const activeTab = this.subscriptionPicker?.querySelector('.subscription-picker__tab.is-active');
        if (!activeTab) return '';
        const planId = activeTab.dataset.sellingPlanId;
        const plan = this.subscriptionData.sellingPlans.find(sp => String(sp.id) === String(planId));
        return plan ? plan.name : '';
    }

    /**
     * Find the matching selling plan ID for a product element by matching
     * the active frequency name from the subscription picker.
     * Each product has its own selling plans with different IDs.
     */
    static findMatchingSellingPlanId(element, activePlanName, dataAttr) {
        if (!activePlanName || !element) return '';
        const plansJson = element.getAttribute(dataAttr);
        if (!plansJson) return '';
        try {
            const plans = JSON.parse(plansJson);
            const match = plans.find(p => p.name === activePlanName);
            return match ? String(match.id) : '';
        } catch {
            return '';
        }
    }

    toggleFaqItem(e) {
        e.currentTarget
            .querySelector(".faq-close")
            .classList.toggle("faq-display-none");

        e.currentTarget.parentNode.classList.toggle("faq-item-active");

        const item = e.currentTarget.parentNode.querySelector(".faq-item-text");
        console.log(item);

        item.slideToggle("250");
    }

    calculateShipping() {
        if (this.querySelector(".sidecart-form__icon")) {
            // calculate shipping date from today + shipping delay exclude weekends
            let shipping_date = new Date(new Date().getTime());

            let shipping_delay = parseInt(
                this.querySelector(".sidecart-form__icon").getAttribute(
                    "data-shipping-delay"
                )
            );

            if (shipping_delay == null) {
                shipping_delay = parseInt(
                    this.querySelector(".cart-form__icon").getAttribute(
                        "data-shipping-delay"
                    )
                );
            }

            for (var i = 0; i < shipping_delay; i++) {
                shipping_date.setDate(shipping_date.getDate() + 1);
                if (shipping_date.getDay() == 6) {
                    shipping_date.setDate(shipping_date.getDate() + 2);
                }
                if (shipping_date.getDay() == 0) {
                    shipping_date.setDate(shipping_date.getDate() + 1);
                }
            }

            // get french date format day month year
            let shipping_date_format = shipping_date.toLocaleDateString("fr-FR", {
                weekday: "long",
                day: "numeric",
                month: "long",
            });

            for (
                let i = 0;
                i < document.querySelectorAll(".sidecart-form__icon").length;
                i++
            ) {
                let html = document.querySelectorAll(".sidecart-form__icon")[i]
                    .innerHTML;
                if (html.indexOf("[date]") > -1) {
                    document.querySelectorAll(".sidecart-form__icon")[i].innerHTML =
                        html.replace("[date]", shipping_date_format);
                }
            }

            for (
                let i = 0;
                i < document.querySelectorAll(".cart-form__icon").length;
                i++
            ) {
                let html = document.querySelectorAll(".cart-form__icon")[i].innerHTML;
                if (html.indexOf("[date]") > -1) {
                    if (document.querySelector(".cart-form__icon")) {
                        document.querySelectorAll(".cart-form__icon")[i].innerHTML =
                            html.replace("[date]", shipping_date_format);
                    }
                }
            }
        }
    }

}

customElements.define('product-form', ProductTemplate);
